export const deviceListItemStyles = {
  listItem: {
    alignItems: "left",
    display: "flex",
    flex: "2",
    width: "40%"
  },
  listLinkStyle: {
    ":hover": {
      color: "#3a56ff"
    },
    color: "#3b5998",
    cursor: "pointer",
    fontSize: "12px",
    textDecoration: "underline"
  },
  row: {
    "@media (min-width: 1024px)": {
      alignItems: "left",
      padding: "10px 20px"
    },
    alignItems: "center",
    backgroundColor: "#fff",
    borderColor: "#ddd",
    borderStyle: "solid",
    borderTop: "none",
    borderWidth: "1px",
    display: "flex",
    fontSize: "13px",
    height: "auto",
    minHeight: "25px",
    padding: "5px"
  }
};

export const deviceListStyles = {
  contentContainer: {
    "@media (min-width: 1024px)": {
      width: "90%"
    },
    display: "flex",
    flexDirection: "column",
    fontSize: "16px",
    maxWidth: "900px",
    width: "95%"
  },
  headerRow: {
    "@media (min-width: 1024px)": {
      alignItems: "left",
      padding: "15px 20px"
    },
    "@media (min-width: 600px)": {
      fontSize: "16px"
    },
    alignItems: "center",
    backgroundColor: "#eee",
    borderColor: "#ddd",
    borderStyle: "solid",
    borderWidth: "1px",
    color: "#333",
    display: "flex",
    fontSize: "13px",
    fontWeight: "bold",
    height: "20px",
    padding: "5px"
  },
  listItem: {
    alignItems: "left",
    display: "flex",
    flex: "2",
    width: "40%"
  },
  listLinkStyle: {
    ":hover": {
      color: "#3a56ff"
    },
    color: "#3b5998",
    cursor: "pointer",
    fontSize: "12px",
    textDecoration: "underline"
  },
  noData: {
    "@media (min-width: 1024px)": {
      padding: "15px 20px"
    },
    fontSize: "13px",
    fontStyle: "italic",
    padding: "15px 5px"
  },
  row: {
    "@media (min-width: 1024px)": {
      alignItems: "left",
      padding: "10px 20px"
    },
    alignItems: "center",
    backgroundColor: "#fff",
    borderColor: "#ddd",
    borderStyle: "solid",
    borderTop: "none",
    borderWidth: "1px",
    display: "flex",
    fontSize: "13px",
    height: "auto",
    minHeight: "25px",
    padding: "5px"
  }
};
